module.exports = __webpack_public_path__ + "img/icon_chevron_right.5c78d876.svg";